export default "__VITE_ASSET__COfrk2Nt__"